import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LockCpt = _resolveComponent("LockCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_LockCpt, {
      ref: "LockCpt",
      value: true,
      checkPwd: $options.onCheckPwd,
      savePwd: $options.onSavePwd,
      onOnHide: $options.onHideEvent
    }, null, 8, ["checkPwd", "savePwd", "onOnHide"])]),
    _: 1
  });
}